import { useState } from 'react';
import ConciergeChat from './ConciergeChat';

export default function ConciergeWidget() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {open && (
        <div className="fixed bottom-24 right-5 z-[60] w-[90vw] max-w-sm h-[70vh] max-h-[560px] bg-white dark:bg-dark-800 rounded-2xl shadow-2xl border border-warm-200 dark:border-dark-700 flex flex-col overflow-hidden animate-slide-in-right">
          <div className="flex items-center justify-between px-4 py-3 bg-dark-900 text-white">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-full bg-gold-500/20 flex items-center justify-center"><i className="ri-robot-2-line text-gold-400" /></span>
              <div>
                <p className="font-display font-semibold text-sm leading-tight">AI Concierge</p>
                <p className="text-white/60 text-xs leading-tight">Proven Realty Group</p>
              </div>
            </div>
            <button onClick={() => setOpen(false)} className="text-white/70 hover:text-white" aria-label="Close chat">
              <i className="ri-close-line text-xl" />
            </button>
          </div>
          <div className="flex-1 overflow-hidden">
            <ConciergeChat variant="panel" />
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((o) => !o)}
        className="fixed bottom-5 right-5 z-[60] w-14 h-14 rounded-full bg-brand-500 text-white shadow-lg hover:bg-brand-600 transition-colors flex items-center justify-center"
        aria-label="Open AI concierge chat"
      >
        <i className={`text-2xl ${open ? 'ri-close-line' : 'ri-message-3-line'}`} />
      </button>
    </>
  );
}
